/**
 * Type scale for the content pages, copied class for class from the theme so a block reads like the
 * product page, the home page and the hand-coded guide. Change a token here, not in a block.
 *
 * Sources: product page h2 and labels (app/product), home strips (components/home-v2),
 * the guide article and policy text (app/guides, components/site/page-kit.tsx).
 * The small Tailwind sizes (text-sm to text-xl) carry their own line height from globals.css, so no leading-* beside them.
 */
export const T = {
  /** Block heading, the product page's section h2 ("Where to use it"). h1 to h3 are Lexend 600 by the .hv-page rule. */
  h2: "text-[24px] font-semibold leading-tight tracking-[-0.02em] text-hv-ink md:text-[30px]",
  /** Group heading on hubs, related links and link lists: the home page's strip heading. */
  h2Small: "text-lg font-semibold text-hv-ink md:text-xl",
  /** Sub-heading inside a block (a step, a markdown h3): the guide's card heading. */
  h3: "text-lg font-semibold text-hv-ink",
  /** Long-form body: the guide article and policy text. */
  body: "text-[15px] leading-[1.8] text-hv-soft",
  /** Lead paragraph in ink: the hero description's size. */
  lead: "text-[17px] leading-relaxed text-hv-ink md:text-lg",
  /** A card's title: the home tiles and the product page's spec values. */
  cardTitle: "text-[15px] font-semibold leading-snug text-hv-ink",
  /** A card's secondary line. */
  cardText: "text-sm text-hv-soft",
  /** Mono label over a value or a card. */
  label: "font-hv-mono text-[11px] uppercase tracking-[0.04em] text-hv-soft",
  /** A figure or strip caption. */
  caption: "text-sm text-hv-soft",
  /** Headline number: the product page's price. */
  figure: "text-[24px] font-semibold leading-none tracking-[-0.02em] tabular-nums text-hv-ink md:text-[30px]",
  /** Stand-alone "See all" link: the product page's orange text action. */
  action: "inline-block text-[15px] font-semibold text-hv-orange transition hover:underline",
  /** Inline link inside body text. */
  inlineLink: "font-medium text-hv-ink underline decoration-hv-orange underline-offset-4 transition hover:text-hv-orange",
  /** Dark pill link: the theme's dark buttons, small. */
  pillDark: "inline-flex items-center rounded-full bg-hv-ink px-4 py-2 text-sm font-semibold text-white transition hover:bg-black",
  /** Outlined pill link: the product page's chips, as links. */
  pillLine: "inline-flex items-center rounded-full border border-hv-line bg-white px-4 py-2 text-sm font-medium text-hv-ink transition hover:border-hv-ink",
  /** White card surface: page-kit's Card. */
  card: "rounded-2xl border border-hv-line bg-white",
  /** Orange dot bullet for lists in body text: policy text's bullets. */
  bullet: "mt-[11px] h-1.5 w-1.5 flex-shrink-0 rounded-full bg-hv-orange",
} as const
